type BaseTemplateDataType = (
  | {
      e2DesignId: string;
      e1TemplateId: string;
      replaceables?: {
        icons: string[];
        images?: undefined;
      };
    }
  | {
      e2DesignId: string;
      e1TemplateId: string;
      replaceables?: {
        images: string[];
        icons?: undefined;
      };
    }
)[];

// Base template ids to be passed into /updateDesignByPrompt endpoint
// e1TemplateId corresponds to the template id in editor1 for MP tracking
const BASE_TEMPLATE_IDS: BaseTemplateDataType = [
  {
    e2DesignId: 'GmKTeJDIR2G6irDrYIYOm4lMfyA5',
    e1TemplateId: '18fcf49b-9099-4704-8f05-0327c0b199f6',
  },
  {
    e2DesignId: 'vV84tJD6sLbMoWmoAIbWHsmGPWRj',
    e1TemplateId: '47ff5d28-2fda-49a2-bde9-04cd4b3a060e',
  },
  {
    e2DesignId: 'ALXTP7PH470abJv3WmGVVhd1gX79',
    e1TemplateId: '594bf689-cc58-4f56-9ae1-d004f1ae9b9c',
  },
  {
    e2DesignId: 'iZom0s3R4zo8nYKjoJyeFWxgqhHe',
    e1TemplateId: '19f601bd-624e-4a2d-90b9-bed0db53fd0b',
  },
  {
    e2DesignId: 'ez20uOEktQg9fW8jlStFnxSIpQF6',
    e1TemplateId: '18fcf49b-9099-4704-8f05-0327c0b199f6',
  },
  {
    e2DesignId: '3Yd3JpltCOs1q3VRqZeNT45tuyiu',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'm3VVmtNAF5mAxdLIlofHq0oymrUK',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'cTPDpDGs68xlAMQpi9fG3rKluAs5',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'mGbGXnRs7WlsLGE2ghaXQcvZM7j0',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'YZawibcMe13B3hTwp35lKHJvCCld',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'JXjemYntl8Y29kxZrBrGniIa0Fe1',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'ietKJvVynFgU5Wwlv08UsDbW65TY',
    e1TemplateId: '',
  },
  {
    e2DesignId: 'bQTnlAdOkkq7vvLyAnFx69D6zZfI',
    e1TemplateId: '',
  },
  // Templates with icon replaceables
  {
    e2DesignId: 'cr1lpuQwd7Vo3ZVnWksNGFkP8qxw',
    e1TemplateId: '',

    replaceables: {
      icons: ['002.3U261g08xE7GK4Af3OMkSG2a'],
    },
  },
  {
    e2DesignId: 'm531IxP8HUTOeQVLJ5DcP6sH8RKV',
    e1TemplateId: '',
    replaceables: {
      icons: [
        '002.liiOL4BnGCSRIIb1yXzSnSH4',
        '002.SGZMFK6wnSXOktXPS0Cj7ejp',
        '002.we2Cy6bRa0JUGRkeD3pyjiuG',
        '002.V3n2akxj3vfojhH5phews8K2',
        '002.idVkZSNTFtHgVzWiziuAtstL',
        '002.4Kd5frwVgaDpZDynZY3P6eJF',
        '002.4BLX2QAvz7tiTLR019peFYwf',
        '002.W3DJrisTfXtSiBNZ4dYRXWsl',
      ],
    },
  },
  {
    e2DesignId: 'ZGMS4r3ddYDCv0dlW7tSC5HrQ6hh',
    e1TemplateId: '',
    replaceables: {
      icons: [
        '002.fxJqQt1NVoQodAmnO9mluOBJ',
        '002.B6kr0tbpHXclB8S8jjFsjFyv',
        '002.U7HWSCCAZn0lPVfPJgyTdmDV',
        '002.kJnMCmMpUD2jERieBtO4BQQp',
        '002.qysEXWhANGW7Rhudt7iUAwDN',
        '002.7WrK5PemizwMtF4dBVOwB5xV',
        '002.Ng02Lwpb10TmEBYfEfvLtWsJ',
        '002.YrstUcfxLEwn7woAmHTRN93L',
        '002.Pgrm87MHKgLhvuoQ2ZdQaWiY',
      ],
    },
  },
  {
    e2DesignId: 'OC1UNW25xYyRgPesWOHsmEtESJT4',
    e1TemplateId: '',
    replaceables: {
      icons: ['002.yM7iWDU4ze6JFr0v6B6Ikfhu', '002.kgRHnGEJhxW93dsojV6VTVeQ', '002.wLXvY925Xl91qgKqpxTAhzy8'],
    },
  },
  // Templates with image replaceables
  {
    e2DesignId: 'Sl89JMkz9xeR3D8BHFQQIlxr1N1s',
    e1TemplateId: '',
    replaceables: {
      images: ['007.WXI9ur1QZz9ViDzcQuMl0vxz'],
    },
  },
  {
    e2DesignId: 'ytL4UluhTcpYJQQTmM3sgGXeItFs',
    e1TemplateId: '',
    replaceables: {
      images: ['007.fqTxMuq6TdnNXVswKVG3Axnk'],
    },
  },
  {
    e2DesignId: 'ihUExulGWuW8ZN44Eh6x41zdYwcv',
    e1TemplateId: '',
    replaceables: {
      images: ['007.vaopDRDTv60o1AHFtz6NxulO'],
    },
  },
  {
    e2DesignId: '5jjTW2IBRV1MY9ADjaR9fvWq2nfq',
    e1TemplateId: '',
    replaceables: {
      images: ['007.Hfba1YlYg8FDtA057mwDclRb'],
    },
  },
  {
    e2DesignId: 'ELiVJg7RNgdTCwVtVjgPQ7o439ln',
    e1TemplateId: '',
    replaceables: {
      images: ['007.gG1eW4fEosjTl9lyuopcioLe'],
    },
  },
  {
    e2DesignId: '8kaYZMNhJLdR2gWiwMLCMdnkZKGp',
    e1TemplateId: '',
    replaceables: {
      images: ['007.vIaBXhrZkOAHIqkQrcTxF5hE'],
    },
  },
  {
    e2DesignId: 'oRcHTmpuPz7YOGlzUqKhWAvfbbeU',
    e1TemplateId: '',
    replaceables: {
      images: ['007.rusxGtAhQ0m8irU57uOsro1G'],
    },
  },
];

const SKIP_COLOR_SHUFFLE_TEMPLATES = ['3Yd3JpltCOs1q3VRqZeNT45tuyiu', 'iZom0s3R4zo8nYKjoJyeFWxgqhHe'];

const DEFAULT_COLOR_PALETTES = [
  ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#E76F51'],
  ['#D8E2DC', '#FFE5D9', '#FFCAD4', '#F4ACB7', '#9D8189'],
  ['#DDEDAA', '#F0CF65', '#D7816A', '#BD4F6C'],
  ['#DB636C', '#F1FAEE', '#A8DADC', '#457B9D', '#1D3557'],
  ['#0FA3B1', '#B5E2FA', '#F9F7F3', '#EDDEA4', '#F7A072'],
  ['#F4F1DE', '#E07A5F', '#3D405B', '#81B29A', '#F2CC8F'],
  ['#1F363D', '#40798C', '#70A9A1', '#9EC1A3', '#CFE0C3'],
  ['#F94144', '#F3722C', '#F8961E', '#F9844A', '#F9C74F', '#90BE6D', '#43AA8B', '#4D908E', '#577590', '#277DA1'],
  ['#CC6666', '#FF9999', '#663333', '#FFCCCC', '#FFFFFF'],
  ['#6699CC', '#99CCFF', '#003366', '#66CCFF', '#FFFFFF'],
];

// Percent of the time we should perform colour shuffle
// Other times we should keep the original design's colours
const SHUFFLE_COLORS_PERCENT = 80;

export { BASE_TEMPLATE_IDS, SKIP_COLOR_SHUFFLE_TEMPLATES, SHUFFLE_COLORS_PERCENT, DEFAULT_COLOR_PALETTES };
